import React from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { firestore } from '../../firebase/firebase-utils';
import TextEditor from '../../Text-Editor'
import KeywordsField from '../../Text-Editor/keywords'
import Code from '../../Text-Editor/code.prettier'

class EditorConvertToHTML extends React.Component {
  state = {
    modalShow: false,
    category: "FEED",
    title: '',
    descrip: '',
    keys: [],
    code: null
  }


  postData = () => {
    let current_datetime = new Date()
    let formatted_date = `${current_datetime.getFullYear()}-${(current_datetime.getMonth() + 1)}-${current_datetime.getDate()} || ${current_datetime.getHours()}:${current_datetime.getMinutes()}:${current_datetime.getSeconds()}`;
    console.log(formatted_date);

    if (this.state.category === "FEED") { // posting queries

      if (this.state.descrip !== '' && this.state.keys.length !== 0) { // validating feeeds
        firestore.collection("queries").doc().set(
          {
            discrp: this.state.descrip,
            username: this.props.user.displayName,
            useremail: this.props.user.email,
            userimage: this.props.user.photoURL,
            uid: this.props.user.uid,
            posttime: formatted_date,
            order: Date.now(),
            category: this.state.category,
            keys: this.state.keys,
            likes: [],
            comments: [],
            saved: []
          }).then(() => {
            console.log("Document written successfully")
            this.setState({ modalShow: false })
          }).catch((error) => {
            window.alert(error)
          });
      } else {
        window.alert("Fill all the fields")
      }

    } else if (this.state.category === "QUERY") {// posting queries

      if (this.state.title !== '' && this.state.descrip !== '' && this.state.keys.length !== 0) { // validaing text inputs
        firestore.collection("queries").doc().set(
          {
            title: this.state.title,
            discrp: this.state.descrip,
            username: this.props.user.displayName,
            useremail: this.props.user.email,
            userimage: this.props.user.photoURL,
            uid: this.props.user.uid,
            posttime: formatted_date,
            order: Date.now(),
            category: this.state.category,
            keys: this.state.keys,
            code: this.state.code
          }).then(() => {
            console.log("Document written successfully")
            this.setState({ modalShow: false })
          }).catch((error) => {
            window.alert(error)
          });
      }
      else {
        window.alert("Fill all fields")
      }
    } else { window.alert("Invalid category") }
  }

  DescripCall = (e) => {
    this.setState({ descrip: e })
  }

  CodeTextCall = (e) => {
    this.setState({ code: e })
  }

  KeywordCall = (list) => {
    if (list !== '') {
      this.setState({ keys: list })
      console.log(this.state.keys)
    }
  }

  DeleteKey = (e) => {
    //deleting keyword
    var delKey = e;
    if (delKey !== '') {
      var keys = this.state.keys;
      keys = keys.filter(key => key !== delKey)
      this.setState({ keys })
    }
  }

  render() {
    return (
      <div>
        <button className="floatingBtn" onClick={() => this.setState({ modalShow: true })}>+</button>
        <Modal
          size='lg'
          aria-labelledby="contained-modal-title-vcenter"
          centered show={this.state.modalShow} onHide={() => this.setState({ modalShow: false })}
          style={{ backgroundColor: '#057BD0' }}
        >
          <Modal.Body>
            <h6>Category:</h6>
            <Form.Control as="select" onChange={(e) => this.setState({ category: e.target.value })} value={this.state.category}>
              <option>FEED</option>
              <option>QUERY</option>
            </Form.Control>
            <br />
            {this.state.category === "QUERY" ?
              <>
                <Form.Control
                  placeholder="Title of your query ...."
                  aria-label="Title of your query ...."
                  aria-describedby="basic-addon1"
                  id="queryTitle"
                  onChange={(e) => this.setState({ title: e.target.value })}
                />
                <br />
              </>
              : ""
            }
            <TextEditor callFunction={this.DescripCall.bind(this)} />
            <br />
            {this.state.category === "QUERY" ?
              <>
                <Code callFunction={this.CodeTextCall.bind(this)} />
              </>
              : ""
            }
            <br />
            <KeywordsField placeholder="Add related keywords" callFunction={this.KeywordCall.bind(this)} delete={this.DeleteKey.bind(this)} collection="queries" />
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => this.setState({ modalShow: false })}>
              Close
              </Button>
            <Button variant="primary" onClick={() => this.postData()}>
              post
              </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default EditorConvertToHTML;
